import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function JobListLoadingState() {
  const { t } = useTranslation();

  return (
    <div className="text-center py-16">
      <Loader2 className="w-12 h-12 text-primary mx-auto mb-4 animate-spin" />
      <p className="text-muted-foreground">{t('MatchingJobs.loading')}</p>
    </div>
  );
}
